import * as z from 'zod';

export const categoryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type CategoryQueryLinkerSchema = z.infer<typeof categoryQueryLinkerSchema>;
